// TES-1413 — copying text the server is still producing ("Kopiera" stores
// the note first and copies the stored text).
//
// Safari allows a clipboard write only while the click is being handled:
// `writeText` called after awaiting a request is refused there, so the copy
// silently failed and only the manual-copy hint was left. ClipboardItem
// takes the text as a promise, so the write starts inside the click and
// completes when the text arrives. Where that is not supported, or refused,
// `writeText` is tried once the text is in. Never throws: false means the
// text must be copied by hand.
export async function copyPendingText(text: Promise<string>): Promise<boolean> {
  const clipboard =
    typeof navigator !== "undefined" ? navigator.clipboard : undefined;
  if (!clipboard) return false;
  if (
    typeof ClipboardItem !== "undefined" &&
    typeof clipboard.write === "function"
  ) {
    try {
      await clipboard.write([
        new ClipboardItem({
          "text/plain": text.then((t) => new Blob([t], { type: "text/plain" })),
        }),
      ]);
      return true;
    } catch {
      // Fall through to writeText.
    }
  }
  try {
    await clipboard.writeText(await text);
    return true;
  } catch {
    return false;
  }
}

/** Selects an element's text, so a failed copy can be finished with Cmd+C. */
export function selectElementText(el: Element | null): void {
  if (!el || typeof window === "undefined") return;
  const selection = window.getSelection();
  if (!selection) return;
  selection.removeAllRanges();
  const range = document.createRange();
  range.selectNodeContents(el);
  selection.addRange(range);
}
